import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { data, exec } = useRequest({
    url: '',
    name: 'GET_USER_LIST',
    method: 'GET',
  });
  useEffect(() => {
    if (params) {
      let url = `/api/system/users`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
          url += `${key}=${params[key]}`;
        } else if (key === 'name' && params[key] !== '' && params[key] !== null) {
          url += '&';
          url += `${key}=${params[key]}`;
        }
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || [], exec];
});
